import type { RumEvent } from '@datadog/browser-rum'

import { getBrowserPath } from 'routing/pagePaths'

// A public link carries its token in the fragment of `/s#<token>`, under the
// app's base path on PR builds. The fragment never reaches a server, but RUM
// records the page URL on every event.
const withoutShareToken = (url: string): string => {
    let parsed: URL
    try {
        parsed = new URL(url)
    } catch {
        return url
    }
    if (
        parsed.pathname !== getBrowserPath('aiReportSharedPage') ||
        !parsed.hash
    ) {
        return url
    }
    parsed.hash = ''
    return parsed.toString()
}

export function scrubShareToken(event: RumEvent): void {
    event.view.url = withoutShareToken(event.view.url)
    if (event.view.referrer) {
        event.view.referrer = withoutShareToken(event.view.referrer)
    }
}
